import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const LockIcon = ({ className, ...props }: React.ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={mergeClassNames('w-[18px] h-[18px]', className)}
    {...props}
  >
    <path d="M5 9V6a5 5 0 0 1 10 0v3M2.5 9h15a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-7A1.5 1.5 0 0 1 2.5 9Z" />
  </svg>
);

export default LockIcon;
